<template>
    <div class="container-fluid">
        <div class="row" v-if="isValidData">
            <div class="col-12">
                <div class="table-responsive">
                    <div class="table-wrapper">
                      <table class="table table-sm table-striped comparison-table" style="min-width: 1000px">
                        <template v-if="!isUserSpecial">
                          <tr>
                              <th rowspan="2" colspan="2" class="text-center">Таққослаш элементлари</th>
                              <th rowspan="2" class="text-center">Баҳолаш объекти</th>
                              <th :colspan="realEstate.newComparison.analogs.length" class="text-center">
                                  Таққослаш объекти(аналоглар)
                              </th>
                          </tr>
                          <tr>
                              <th width="17%" class="text-center" v-for="(analog,index) in realEstate.newComparison.analogs" :key="index" style="position: relative">
                                  аналог {{index + 1}}
                                  <div class="height-auto" v-if="canSelect">
                                      <v-select
                                              :options="analogs"
                                              label="name"
                                              v-model="analog.apiAnalog"
                                              :clearable="false"
                                      >
                                          <template slot="option" slot-scope="option" v-if="option && option.name">
                                              <div v-html="option.name" style="font-weight: bold"></div>
                                              <template v-if="option.totalArea">
                                                  <div>Умумий ер майдон {{option.totalArea}} м²</div>
                                              </template>
                                              <template v-if="option.usefulArea">
                                                  <div>Умумий майдон {{option.usefulArea}} м² </div>
                                              </template>
                                              <template>
                                                  <div>{{option.price | currency('', 2, { thousandsSeparator: ' ' }) }} {{option.priceUnit.symbol}}</div>
                                              </template>
                                          </template>
                                          <span slot="no-options">{{$t("messages.combo.empty")}}</span>
                                      </v-select>
                                  </div>
                                  <!--<div style="font-style: italic; color:grey;" v-if="isBuildingTypes">-->
                                  <!--{{getBuildingType(analog.categoryCode)[0].name}}-->
                                  <!--</div>-->
                              </th>
                          </tr>
                          <tr>
                              <td class="text-center" rowspan="3">Сотиш баҳоси</td>
                              <td>АҚШ доллардаги қиймат</td>
                              <td></td>
                              <td class="text-right" v-for="(analog,index) in realEstate.newComparison.analogs" :key="index">
                                  {{analog.priceCurrency | currency('', 2, { thousandsSeparator: ' ' })}}
                              </td>
                          </tr>
                          <tr>
                              <td>
                                  Ўз.Рес.МБ.Савдога қуйилган ёки сотилиш
                                  <br>
                                  санасидаги валюта (АКШ доллар) курси
                                <div class="pull-right mr-5 mt-2" v-if="realEstate.newComparison.exchangeRate && realEstate.newComparison.exchangeRate > 0">
                                  1 USD = {{realEstate.newComparison.exchangeRate | currency('', 2, { thousandsSeparator: ' ' })}} UZS ({{realEstate.newComparison.exchangeRateDate}})
                                </div>
                              </td>
                              <td></td>
                              <td class="text-right" v-for="(analog,index) in realEstate.newComparison.analogs" :key="index">
                                  {{analog.currencyRate | currency('', 2, { thousandsSeparator: ' ' })}}
                              </td>
                          </tr>
                          <tr>
                              <td>Ўзбекистон сўмидаги баҳоси</td>
                              <td></td>
                              <td class="text-right" v-for="(analog,index) in realEstate.newComparison.analogs" :key="index">
                                  {{analog.priceUzs | currency('', 2, { thousandsSeparator: ' ' })}}
                              </td>
                          </tr>
                          <tr>
                              <td class="text-center" rowspan="2">Фойдаланилган маълумотлар манбаи</td>
                              <td>Манба</td>
                              <td></td>
                              <td v-for="(analog,index) in realEstate.newComparison.analogs" :key="index" class="text-center">
                                  {{analog.source}}
                              </td>
                          </tr>
                          <tr>
                              <td>Маълумотлар баъзасида сақланаётган хавола (ссылка)</td>
                              <td></td>
                              <td v-for="(analog,index) in realEstate.newComparison.analogs" :key="index" class="text-center">
                                  эълон рақами: {{analog.id}}
                                  <br />
                                  <a :href="`https://e-rieltor.uz/products/product/${analog.id}`" target="_blank">https://e-rieltor.uz/products/product/{{analog.id}}</a>
                              </td>
                          </tr>
                          <tr>
                              <td class="text-center">
                                 <span v-if="isMultiStorey"> Умумий майдони</span>
                                  <span v-else>Умумий ер майдони</span>
                              </td>
                              <td></td>
                              <td class="text-right">{{realEstate.newComparison.totalArea}}</td>
                              <td v-for="(analog,index) in realEstate.newComparison.analogs" :key="index" class="text-right">
                                  {{analog.totalArea}}
                              </td>
                          </tr>
                          <template v-if="!isMultiStorey">
                              <tr>
                                  <td class="text-center">Умумий майдони</td>
                                  <td></td>
                                  <td class="text-right">{{realEstate.hasTotalArea ? realEstate.newComparison.evlTotalArea : realEstate.newComparison.usefulArea }} </td>
                                  <td v-for="(analog,index) in realEstate.newComparison.analogs" :key="index" class="text-right">
                                      {{analog.usefulArea}}
                                  </td>
                              </tr>
                          </template>
                          <tr>
                              <td class="text-center">1 м2 учун нарх</td>
                              <td></td>
                              <td></td>
                              <td v-for="(analog,index) in realEstate.newComparison.analogs" :key="index" class="text-right">
                                  {{analog.price.perAreaUnitFixed | currency('', 2, { thousandsSeparator: ' ' })}}
                              </td>
                          </tr>
                          <tr>
                              <td class="text-center" rowspan="3">Топширилаётган мулк хукуки</td>
                              <td>Ҳуқуқ тури</td>
                              <td class="text-center">Эгалик</td>
                              <td v-for="(analog,index) in realEstate.newComparison.analogs" :key="index" class="text-center">
                                  Эгалик
                              </td>
                          </tr>
                          <tr>
                              <td>Тузатиш</td>
                              <td></td>
                              <td v-for="(analog,index) in realEstate.newComparison.analogs" :key="index" class="text-center">
                                  1
                              </td>
                          </tr>
                          <tr>
                              <td>1 м.кв учун тузатишдан кейинги киймат</td>
                              <td></td>
                              <td v-for="(analog,index) in realEstate.newComparison.analogs" :key="index" class="text-right">
                                  {{analog.price.perAreaUnitFixed | currency('', 2, { thousandsSeparator: ' ' })}}
                              </td>
                          </tr>
                          <!-- Объектнинг ижара шартномаси буйича юкламалари -->
                          <tr>
                              <td class="text-center" rowspan="3">Объектнинг ижара шартномаси буйича юкламалари</td>
                              <td>Мавжудлиги</td>
                              <td class="text-center">Ахборот мавжуд эмас</td>
                              <td v-for="(analog,index) in realEstate.newComparison.analogs" :key="index" class="text-center">
                                  Ахборот мавжуд эмас
                              </td>
                          </tr>
                          <tr>
                              <td>Тузатиш</td>
                              <td></td>
                              <td v-for="(analog,index) in realEstate.newComparison.analogs" :key="index" class="text-center">
                                  1
                              </td>
                          </tr>
                          <tr>
                              <td>1 м.кв учун тузатишдан кейинги киймат</td>
                              <td></td>
                              <td v-for="(analog,index) in realEstate.newComparison.analogs" :key="index" class="text-right">
                                  {{analog.price.perAreaUnitFixed | currency('', 2, { thousandsSeparator: ' ' })}}
                              </td>
                          </tr>
                          <!-- end -->
                          <!-- Сервитутлар ва ижтимоий кушимча юкламалар -->
                          <tr>
                              <td class="text-center" rowspan="3">Сервитутлар ва ижтимоий кушимча юкламалар</td>
                              <td>Мавжудлиги</td>
                              <td class="text-center">мавжуд эмас</td>
                              <td v-for="(analog,index) in realEstate.newComparison.analogs" :key="index" class="text-center">
                                  мавжуд эмас
                              </td>
                          </tr>
                          <tr>
                              <td>Тузатиш</td>
                              <td></td>
                              <td v-for="(analog,index) in realEstate.newComparison.analogs" :key="index" class="text-center">
                                  1
                              </td>
                          </tr>
                          <tr>
                              <td>1 м.кв учун тузатишдан кейинги киймат</td>
                              <td></td>
                              <td v-for="(analog,index) in realEstate.newComparison.analogs" :key="index" class="text-right">
                                  {{analog.price.perAreaUnitFixed | currency('', 2, { thousandsSeparator: ' ' })}}
                              </td>
                          </tr>
                          <!-- end -->
                          <!-- Объект таркибидаги ер участкасига булган хукуклар -->
                          <tr>
                              <td class="text-center" rowspan="3">Объект таркибидаги ер участкасига булган хукуклар</td>
                              <td>Ҳуқуқ тури</td>
                              <td class="text-center">Доимий фойдаланиш</td>
                              <td v-for="(analog,index) in realEstate.newComparison.analogs" :key="index" class="text-center">
                                  Доимий фойдаланиш
                              </td>
                          </tr>
                          <tr>
                              <td>Тузатиш</td>
                              <td></td>
                              <td v-for="(analog,index) in realEstate.newComparison.analogs" :key="index" class="text-center">
                                  1
                              </td>
                          </tr>
                          <tr>
                              <td>1 м.кв учун тузатишдан кейинги киймат</td>
                              <td></td>
                              <td v-for="(analog,index) in realEstate.newComparison.analogs" :key="index" class="text-right">
                                  {{analog.price.perAreaUnitFixed | currency('', 2, { thousandsSeparator: ' ' })}}
                              </td>
                          </tr>
                          <!-- end -->
                          <!-- Молиялаштириш шартлари -->
                          <tr>
                              <td class="text-center" rowspan="4">Молиялаштириш шартлари</td>
                              <td>Тўлов тури</td>
                              <td class="text-center">Олдиндан тулов</td>
                              <td v-for="(analog,index) in realEstate.newComparison.analogs" :key="index" class="text-center">
                                  Олдиндан тулов
                              </td>
                          </tr>
                          <tr>
                              <td>Тузатиш</td>
                              <td></td>
                              <td v-for="(analog,index) in realEstate.newComparison.analogs" :key="index" class="text-center">
                                  0%
                              </td>
                          </tr>
                          <tr>
                              <td>Бўлиб тўлаш муддати ой</td>
                              <td></td>
                              <td v-for="(analog,index) in realEstate.newComparison.analogs" :key="index" class="text-center">
                                  0
                              </td>
                          </tr>
                          <tr>
                              <td>1 м.кв учун тузатишдан кейинги киймат</td>
                              <td></td>
                              <td v-for="(analog,index) in realEstate.newComparison.analogs" :key="index" class="text-right">
                                  {{analog.price.perAreaUnitFixed | currency('', 2, { thousandsSeparator: ' ' })}}
                              </td>
                          </tr>
                          <!-- end -->
                          <!-- Хақ тўлаш шакили -->
                          <tr>
                              <td class="text-center" rowspan="3">Хақ тўлаш шакили</td>
                              <td>Тўлов шакли</td>
                              <td class="text-center">Накт ёки пул кўчириш (сўм,у.е...)</td>
                              <td v-for="(analog,index) in realEstate.newComparison.analogs" :key="index" class="text-center">
                                  Накт ёки пул кўчириш (сўм,у.е...)
                              </td>
                          </tr>
                          <tr>
                              <td>Тузатиш</td>
                              <td></td>
                              <td v-for="(analog,index) in realEstate.newComparison.analogs" :key="index" class="text-center">
                                  1
                              </td>
                          </tr>
                          <tr>
                              <td>1 м.кв учун тузатишдан кейинги киймат</td>
                              <td></td>
                              <td v-for="(analog,index) in realEstate.newComparison.analogs" :key="index" class="text-right">
                                  {{analog.price.perAreaUnitFixed | currency('', 2, { thousandsSeparator: ' ' })}}
                              </td>
                          </tr>
                          <!-- end -->
                          <!-- Сотув шартлари -->
                          <tr>
                              <td rowspan="3" class="text-center">Сотув шартлари</td>
                              <td>Холати</td>
                              <td></td>
                              <td v-for="(analog,index) in realEstate.newComparison.analogs" :key="index" class="text-center">
                                  {{analog.termsOfSale}}
                              </td>
                          </tr>
                          <tr>
                              <td>Манбага нисбатан тузатиш</td>
                              <td></td>
                              <td v-for="(analog,index) in realEstate.newComparison.analogs" :key="index" class="text-center">
                                  {{analog.fix.termsOfSale}}
                              </td>
                          </tr>
                          <tr>
                              <td>1 м.кв учун тузатишдан кейинги киймат</td>
                              <td></td>
                              <td v-for="(analog,index) in realEstate.newComparison.analogs" :key="index" class="text-right">
                                  {{analog.price.termsOfSaleFixed | currency('', 2, { thousandsSeparator: ' ' })}}
                              </td>
                          </tr>
                          <!-- -->
                          <!-- Сотув нархининг ижара ставкаси билан бозорга оид булмаган алокаси -->
                          <tr>
                              <td class="text-center">Сотув нархининг ижара ставкаси билан бозорга оид булмаган алокаси</td>
                              <td></td>
                              <td class="text-center">Мавжуд эмас</td>
                              <td v-for="(analog,index) in realEstate.newComparison.analogs" :key="index" class="text-center">
                                  Мавжуд эмас
                              </td>
                          </tr>
                          <!-- end -->
                          <!-- Ривожланиш учун субсидия ёки имтиёзлар -->
                          <tr>
                              <td class="text-center" rowspan="3">Ривожланиш учун субсидия ёки имтиёзлар</td>
                              <td></td>
                              <td class="text-center">Мавжуд эмас</td>
                              <td v-for="(analog,index) in realEstate.newComparison.analogs" :key="index" class="text-center">
                                  Мавжуд эмас
                              </td>
                          </tr>
                          <tr>
                              <td>Тузатиш</td>
                              <td></td>
                              <td v-for="(analog,index) in realEstate.newComparison.analogs" :key="index" class="text-center">
                                  1
                              </td>
                          </tr>
                          <tr>
                              <td>1 м.кв учун тузатишдан кейинги киймат</td>
                              <td></td>
                              <td v-for="(analog,index) in realEstate.newComparison.analogs" :key="index" class="text-right">
                                  {{analog.price.termsOfSaleFixed | currency('', 2, { thousandsSeparator: ' ' })}}
                              </td>
                          </tr>
                          <!-- end -->
                          <!-- Хариддан кейинги харажатлар -->
                          <tr>
                              <td class="text-center" rowspan="3">Хариддан кейинги харажатлар</td>
                              <td>
                                  Бино ёки уйнинг бир кисмини демонтаж килиш
                                  <br />
                                  харажатлари,ер участкасининг ифлосланишини
                                  <br>
                                  бартараф этиш харажатлари
                              </td>
                              <td class="text-center">Мавжуд эмас</td>
                              <td v-for="(analog,index) in realEstate.newComparison.analogs" :key="index" class="text-center">
                                  Мавжуд эмас
                              </td>
                          </tr>
                          <tr>
                              <td>Тузатиш</td>
                              <td></td>
                              <td v-for="(analog,index) in realEstate.newComparison.analogs" :key="index" class="text-center">
                                  1
                              </td>
                          </tr>
                          <tr>
                              <td>1 м.кв учун тузатишдан кейинги киймат</td>
                              <td></td>
                              <td v-for="(analog,index) in realEstate.newComparison.analogs" :key="index" class="text-right">
                                  {{analog.price.termsOfSaleFixed | currency('', 2, { thousandsSeparator: ' ' })}}
                              </td>
                          </tr>
                          <!-- end -->
                          <!-- Бозор шартлари -->
                          <template v-if="realEstate.fixByIndex">
                              <tr>
                                  <td class="text-center" rowspan="4">Бозор шартлари</td>
                                  <td>
                                      Савдога кўйилган ёки сотилиш санаси
                                  </td>
                                  <td class="text-center">{{realEstate.newComparison.salesDate}}</td>
                                  <td v-for="(analog,index) in realEstate.newComparison.analogs" :key="index" class="text-center">
                                      {{analog.salesDate}}
                                  </td>
                              </tr>
                              <tr>
                                  <td>Кимматлашув коффиценти</td>
                                  <td class="text-center">{{realEstate.newComparison.indexCoefficient}}</td>
                                  <td v-for="(analog,index) in realEstate.newComparison.analogs" :key="index" class="text-center">
                                      {{analog.indexCoefficient}}
                                  </td>
                              </tr>
                          </template>
                          <!-- end -->
                          <template v-else>
                              <!-- Бозор шартлари курс буйича -->
                              <tr>
                                  <td class="text-center" rowspan="4">
                                    <span v-if="realEstate.newComparison.coefficient && realEstate.newComparison.coefficient.buildingPeriod">
                                      Даврга нисбатан
                                    </span>
                                    <span v-else>Бозор шартлари</span>
                                  </td>
                                  <td>
                                      Савдога кўйилган ёки сотилиш санаси
                                  </td>
                                  <td class="text-center">{{realEstate.newComparison.salesDate}}</td>
                                  <td v-for="(analog,index) in realEstate.newComparison.analogs" :key="index" class="text-center">
                                      {{analog.salesDate}}
                                  </td>
                              </tr>
                              <tr v-if="realEstate.newComparison.coefficient && realEstate.newComparison.coefficient.buildingPeriod">
                                  <td></td>
                                  <td class="text-right">{{realEstate.newComparison.coefficient.buildingPeriod}}</td>
                                  <td class="text-right" v-for="(analog,index) in realEstate.newComparison.analogs" :key="index">
                                      {{analog.coefficient.buildingPeriod}}
                                  </td>
                              </tr>
                              <tr v-else>
                                <td>Валюта курси</td>
                                <td class="text-right">{{realEstate.newComparison.exchangeRate | currency('', 2, { thousandsSeparator: ' ' })}}</td>
                                <td class="text-right" v-for="(analog,index) in realEstate.newComparison.analogs" :key="index">
                                  {{analog.currencyRate | currency('', 2, { thousandsSeparator: ' ' })}}
                                </td>
                              </tr>
                          </template>
                          <tr>
                              <td>Тузатиш</td>
                              <td></td>
                              <td v-for="(analog,index) in realEstate.newComparison.analogs" :key="index" class="text-center">
                                  {{analog.fix.source | currency('', 4, { thousandsSeparator: ' ' })}}
                              </td>
                          </tr>
                          <tr>
                              <td>1 м.кв учун тузатишдан кейинги киймат</td>
                              <td></td>
                              <td v-for="(analog,index) in realEstate.newComparison.analogs" :key="index" class="text-right">
                                  {{analog.price.sourceFixed | currency('', 2, { thousandsSeparator: ' ' })}}
                              </td>
                          </tr>
                          <!-- end -->
                          <!-- Объектнинг Жойлашган ери -->
                          <tr>
                              <td class="text-center" :rowspan="isNotRegionFixCalculated || isRegionFixCalculated ? 9 : 3">Объектнинг Жойлашган ери</td>
                              <td>Объект жойлашган туман</td>
                              <td class="text-center">{{realEstate.newComparison.regionName}}</td>
                              <td v-for="(analog,index) in realEstate.newComparison.analogs" :key="index" class="text-center">
                                  {{analog.regionName}}
                              </td>
                          </tr>
                          <template v-if="isNotRegionFixCalculated">
                              <tr>
                                  <td>Худуд даромади (Млярд сўм)</td>
                                  <td class="text-center">{{realEstate.newComparison.provinceIncome}}</td>
                                  <td v-for="(analog,index) in realEstate.newComparison.analogs" :key="index" class="text-center">
                                      {{analog.provinceIncome}}
                                  </td>
                              </tr>
                              <tr>
                                  <td>Ахоли сони (мингда)</td>
                                  <td class="text-center">{{realEstate.newComparison.populace}}</td>
                                  <td v-for="(analog,index) in realEstate.newComparison.analogs" :key="index" class="text-center">
                                      {{analog.populace}}
                                  </td>
                              </tr>
                              <tr>
                                  <td>Вилоят ёки шахар ахоли жон бошига йиллик даромадининг худуд улуши фоизда</td>
                                  <td class="text-center">{{realEstate.newComparison.regionCoefficient | currency('', 2, { thousandsSeparator: ' ' })}} %</td>
                                  <td v-for="(analog,index) in realEstate.newComparison.analogs" :key="index" class="text-center">
                                      {{analog.regionCoefficient | currency('', 2, { thousandsSeparator: ' ' })}} %
                                  </td>
                              </tr>
                          </template>
                          <template v-if="isRegionFixCalculated">
                            <tr>
                              <td>Марказдан узоқлиги</td>
                              <td class="text-center">{{realEstate.newComparison.regionFixCalculated.distanceFromDistrict | currency('', 2, { thousandsSeparator: ' ' })}} м</td>
                              <td v-for="(analog,index) in realEstate.newComparison.analogs" :key="index" class="text-center">
                                {{ analog.regionFixCalculated.distanceFromDistrict | currency('', 2, { thousandsSeparator: ' ' })}} м
                              </td>
                            </tr>
                            <tr>
                              <td class="font-weight-bold">Марказдан узоқлигига коэффициент</td>
                              <td class="text-center">{{realEstate.newComparison.regionFixCalculated.centralRoad | currency('', 2, { thousandsSeparator: ' ' })}} </td>
                              <td v-for="(analog,index) in realEstate.newComparison.analogs" :key="index" class="text-center">
                                {{ analog.regionFixCalculated.centralRoad | currency('', 2, { thousandsSeparator: ' ' })}}
                              </td>
                            </tr>
                            <tr>
                              <td>Алохида кулайлик</td>
                              <td class="text-center">{{realEstate.newComparison.specialComfort}} </td>
                              <td v-for="(analog,index) in realEstate.newComparison.analogs" :key="index" class="text-center">
                                {{ analog.specialComfort}}
                              </td>
                            </tr>
                            <tr>
                              <td class="font-weight-bold">Қулайлик учун коэффициент</td>
                              <td class="text-center">{{realEstate.newComparison.regionFixCalculated.addressAuthority | currency('', 2, { thousandsSeparator: ' ' })}} </td>
                              <td v-for="(analog,index) in realEstate.newComparison.analogs" :key="index" class="text-center">
                                {{ analog.regionFixCalculated.addressAuthority | currency('', 2, { thousandsSeparator: ' ' })}}
                              </td>
                            </tr>
                            <tr>
                              <td class="font-weight-bold">Туман учун коэффициент</td>
                              <td class="text-center">{{realEstate.newComparison.regionFixCalculated.regionCoefficient | currency('', 2, { thousandsSeparator: ' ' })}} </td>
                              <td v-for="(analog,index) in realEstate.newComparison.analogs" :key="index" class="text-center">
                                {{ analog.regionFixCalculated.regionCoefficient | currency('', 2, { thousandsSeparator: ' ' })}}
                              </td>
                            </tr>
                            <tr>
                              <td class="font-weight-bold">Жойлашган жойи коэффициенти (йиғинди)</td>
                              <td class="text-center">{{realEstate.newComparison.regionFixCalculated.total | currency('', 2, { thousandsSeparator: ' ' })}} </td>
                              <td v-for="(analog,index) in realEstate.newComparison.analogs" :key="index" class="text-center">
                                {{ analog.regionFixCalculated.total | currency('', 2, { thousandsSeparator: ' ' })}}
                              </td>
                            </tr>
                          </template>
                          <tr>
                              <td>Тузатиш</td>
                              <td></td>
                              <td v-for="(analog,index) in realEstate.newComparison.analogs" :key="index" class="text-center">
                                  {{analog.fix.region | currency('', 3, { thousandsSeparator: ' ' })}} {{isRegionFixCalculated ? '' : '%'}}
                              </td>
                          </tr>
                          <tr>
                              <td>1 м.кв учун тузатишдан кейинги киймат</td>
                              <td></td>
                              <td v-for="(analog,index) in realEstate.newComparison.analogs" :key="index" class="text-right">
                                  {{analog.price.regionFixed | currency('', 2, { thousandsSeparator: ' ' })}}
                              </td>
                          </tr>
                          <!-- end -->
                          <template v-if="realEstate.newComparison.coefficient && realEstate.newComparison.coefficient.separateBuilding">
                            <!-- Алоҳида бино -->
                            <tr>
                              <td class="text-center" rowspan="4">Алоҳида қурилган бино</td>
                              <td>
                                Алоҳида турган бино / Бинонинг қисмида жойлашган
                              </td>
                              <td class="text-center">
                                {{realEstate.newComparison.separateBuilding ? "Алоҳида бино" : "Бинони бир қисми"}}
                              </td>
                              <td v-for="(analog,index) in realEstate.newComparison.analogs" :key="index" class="text-center">
                                {{analog.separateBuilding ? "Алоҳида бино" : "Бинони бир қисми"}}
                              </td>
                            </tr>
                            <tr>
                              <td></td>
                              <td class="text-center">{{realEstate.newComparison.coefficient.separateBuilding}}</td>
                              <td v-for="(analog,index) in realEstate.newComparison.analogs" :key="index" class="text-center">
                                {{analog.coefficient.separateBuilding}}
                              </td>
                            </tr>
                            <tr>
                              <td>Тузатиш</td>
                              <td></td>
                              <td v-for="(analog,index) in realEstate.newComparison.analogs" :key="index" class="text-center">
                                {{analog.fix.separateBuilding | currency('', 3, { thousandsSeparator: ' ' })}}
                              </td>
                            </tr>
                            <tr>
                              <td>1 м.кв учун тузатишдан кейинги киймат</td>
                              <td></td>
                              <td v-for="(analog,index) in realEstate.newComparison.analogs" :key="index" class="text-right">
                                {{analog.price.separateBuildingFixed | currency('', 2, { thousandsSeparator: ' ' })}}
                              </td>
                            </tr>
                            <!-- end -->
                          </template>
                          <!-- Физик тавсиф фаркига караб тузатиш (бинонинг катта-кичиклиги) -->
                          <template v-if="realEstate.newComparison.buildingType.code === 'RESIDENTIAL_MULTI_STOREY'">
                              <tr>
                                  <td class="text-center" :rowspan="realEstate.newComparison.fix && realEstate.newComparison.fix.areaAnalogCoefficient > 0 ? 4:3">
                                      Физик тавсиф фаркига караб тузатиш
                                      <br />
                                      (бинонинг катта-кичиклиги)
                                  </td>
                                  <td>Умумий фойдали майдони</td>
                                  <td class="text-center">{{realEstate.newComparison.totalArea}}</td>
                                  <td v-for="(analog,index) in realEstate.newComparison.analogs" :key="index" class="text-center">
                                      {{analog.totalArea}}
                                  </td>
                              </tr>
                              <template v-if="realEstate.newComparison.fix && realEstate.newComparison.fix.areaAnalogCoefficient > 0">
                                  <tr>
                                      <td>Тузатиш коеффициенти</td>
                                      <td class="text-center">{{realEstate.newComparison.fix.areaAnalogCoefficient}}</td>
                                      <td v-for="(analog,index) in realEstate.newComparison.analogs" :key="index" class="text-center">
                                          {{analog.fix.areaAnalogCoefficient}}
                                      </td>
                                  </tr>
                              </template>
                              <tr>
                                  <td>Катта - кичиклигига Тузатиш</td>
                                  <td></td>
                                  <td v-for="(analog,index) in realEstate.newComparison.analogs" :key="index" class="text-center">
                                      {{analog.fix.totalArea}}
                                  </td>
                              </tr>
                              <tr>
                                  <td>1 м.кв учун тузатишдан кейинги киймат</td>
                                  <td></td>
                                  <td v-for="(analog,index) in realEstate.newComparison.analogs" :key="index" class="text-right">
                                      {{analog.price.totalAreaFixed | currency('', 2, { thousandsSeparator: ' ' })}}
                                  </td>
                              </tr>
                          </template>
                          <template v-else>
                              <tr>
                                  <td class="text-center" :rowspan="realEstate.newComparison.fix && realEstate.newComparison.fix.areaAnalogCoefficient > 0 ? 4:3">
                                      Физик тавсиф фаркига караб тузатиш
                                      <br />
                                      (бинонинг катта-кичиклиги)
                                  </td>
                                  <td>Умумий фойдали майдони</td>
                                  <td class="text-center">{{realEstate.hasTotalArea ? realEstate.newComparison.evlTotalArea : realEstate.newComparison.usefulArea}}</td>
                                  <td v-for="(analog,index) in realEstate.newComparison.analogs" :key="index" class="text-center">
                                      {{analog.usefulArea}}
                                  </td>
                              </tr>
                              <template v-if="realEstate.newComparison.fix && realEstate.newComparison.fix.areaAnalogCoefficient > 0">
                                  <tr>
                                      <td>Тузатиш коеффициенти</td>
                                      <td class="text-center">{{realEstate.newComparison.fix.areaAnalogCoefficient}}</td>
                                      <td v-for="(analog,index) in realEstate.newComparison.analogs" :key="index" class="text-center">
                                          {{analog.fix.areaAnalogCoefficient}}
                                      </td>
                                  </tr>
                              </template>
                              <tr>
                                  <td>Катта - кичиклигига Тузатиш</td>
                                  <td></td>
                                  <td v-for="(analog,index) in realEstate.newComparison.analogs" :key="index" class="text-center">
                                      {{analog.fix.usefulArea}}
                                  </td>
                              </tr>
                              <tr>
                                  <td>1 м.кв учун тузатишдан кейинги киймат</td>
                                  <td></td>
                                  <td v-for="(analog,index) in realEstate.newComparison.analogs" :key="index" class="text-right">
                                      {{analog.price.usefulAreaFixed | currency('', 2, { thousandsSeparator: ' ' })}}
                                  </td>
                              </tr>
                          </template>
                          <!-- end -->
                          <!-- Курилиш сифати -->
                          <!--<tr>-->
                              <!--<td class="text-center" rowspan="3">Курилиш сифати</td>-->
                              <!--<td>-->
                                  <!--Курилиш тугалланганлиги-->
                              <!--</td>-->
                              <!--<td class="text-center">{{realEstate.newComparison.constructionCompletion}}%</td>-->
                              <!--<td v-for="(analog,index) in realEstate.newComparison.analogs" :key="index" class="text-center">-->
                                  <!--{{analog.constructionCompletion}} %-->
                              <!--</td>-->
                          <!--</tr>-->
                          <!--<tr>-->
                              <!--<td>Тузатиш</td>-->
                              <!--<td></td>-->
                              <!--<td v-for="(analog,index) in realEstate.newComparison.analogs" :key="index" class="text-center">-->
                                  <!--{{analog.fix.constructionCompletion}} %-->
                              <!--</td>-->
                          <!--</tr>-->
                          <!--<tr>-->
                              <!--<td>1 м.кв учун тузатишдан кейинги киймат</td>-->
                              <!--<td></td>-->
                              <!--<td v-for="(analog,index) in realEstate.newComparison.analogs" :key="index" class="text-right">-->
                                  <!--{{analog.price.constructionCompletionFixed | currency('', 2, { thousandsSeparator: ' ' })}}-->
                              <!--</td>-->
                          <!--</tr>-->
                          <!-- end -->
                          <!-- Қурилиш материаллари -->
                          <tr>
                              <td class="text-center" rowspan="4">Қурилиш материаллари</td>
                              <td>
                                  Девори
                              </td>
                              <td class="text-center">
                                  <span v-if="realEstate.newComparison.wall === 'brick_baked'">Пишиқ ғишт</span>
                                  <span v-else-if="realEstate.newComparison.wall === 'brick_crude'">Хом ғишт</span>
                                  <span v-else-if="realEstate.newComparison.wall === 'panel_concrete'">Темир бетон панел</span>
                                  <span v-else-if="realEstate.newComparison.wall === 'wood'">Ёғоч (дарахт)</span>
                                  <span v-else-if="realEstate.newComparison.wall === 'brick_baked_and_crude'">Пишиқ ғишт ва хом ғишт</span>
                                  <span v-else-if="realEstate.newComparison.wall === 'large_blocks'">Шлакаблок</span>
                                  <span v-else-if="realEstate.newComparison.wall === 'gas_block'">Газаблок</span>
                                  <span v-else-if="realEstate.newComparison.wall === 'mixed_bricks'">Аралаш</span>
                                  <span v-else-if="realEstate.newComparison.wall === 'Metallic'">Металл</span>
                                  <span v-else>{{realEstate.newComparison.wall}}</span>
                              </td>
                              <td v-for="(analog,index) in realEstate.newComparison.analogs" :key="index" class="text-center">
                                  <span v-if="analog.wall === 'brick_baked'">Пишиқ ғишт</span>
                                  <span v-else-if="analog.wall === 'brick_crude'">Хом ғишт</span>
                                  <span v-else-if="analog.wall === 'panel_concrete'">Темир бетон панел</span>
                                  <span v-else-if="analog.wall === 'wood'">Ёғоч (дарахт)</span>
                                  <span v-else-if="analog.wall === 'brick_baked_and_crude'">Пишиқ ғишт ва хом ғишт</span>
                                  <span v-else-if="analog.wall === 'large_blocks'">Шлакаблок</span>
                                  <span v-else-if="analog.wall === 'gas_block'">Газаблок</span>
                                  <span v-else-if="analog.wall === 'mixed_bricks'">Аралаш</span>
                                  <span v-else-if="analog.wall === 'Metallic'">Металл</span>
                                  <span v-else>{{analog.wall}}</span>
                              </td>
                          </tr>
                          <tr>
                              <td></td>
                              <td class="text-center">{{realEstate.newComparison.buildingMaterialsCoefficient}}</td>
                              <td v-for="(analog,index) in realEstate.newComparison.analogs" :key="index" class="text-center">
                                  {{analog.buildingMaterialsCoefficient}}
                              </td>
                          </tr>
                          <tr>
                              <td>Тузатиш</td>
                              <td></td>
                              <td v-for="(analog,index) in realEstate.newComparison.analogs" :key="index" class="text-center">
                                  {{analog.fix.buildingMaterials}}
                              </td>
                          </tr>
                          <tr>
                              <td>1 м.кв учун тузатишдан кейинги киймат</td>
                              <td></td>
                              <td v-for="(analog,index) in realEstate.newComparison.analogs" :key="index" class="text-right">
                                  {{analog.price.buildingMaterialsFixed | currency('', 2, { thousandsSeparator: ' ' })}}
                              </td>
                          </tr>
                          <!-- end -->
                          <!-- Архитектуравий услуб -->
                          <tr>
                              <td class="text-center" rowspan="4">Архитектуравий услуб</td>
                              <td>
                                  Архитектуравий услуб
                              </td>
                              <td class="text-center">{{realEstate.newComparison.architecturalStyle}}</td>
                              <td v-for="(analog,index) in realEstate.newComparison.analogs" :key="index" class="text-center">
                                  {{analog.architecturalStyle}}
                              </td>
                          </tr>
                          <tr>
                              <td></td>
                              <td class="text-center">{{realEstate.newComparison.architecturalStyleCoefficient}}%</td>
                              <td v-for="(analog,index) in realEstate.newComparison.analogs" :key="index" class="text-center">
                                  {{analog.architecturalStyleCoefficient}}%
                              </td>
                          </tr>
                          <tr>
                              <td>Тузатиш</td>
                              <td></td>
                              <td v-for="(analog,index) in realEstate.newComparison.analogs" :key="index" class="text-center">
                                  {{analog.fix.architecturalStyle}}%
                              </td>
                          </tr>
                          <tr>
                              <td>1 м.кв учун тузатишдан кейинги киймат</td>
                              <td></td>
                              <td v-for="(analog,index) in realEstate.newComparison.analogs" :key="index" class="text-right">
                                  {{analog.price.architecturalStyleFixed | currency('', 2, { thousandsSeparator: ' ' })}}
                              </td>
                          </tr>
                          <!-- end -->
                          <!-- Бинонинг ёши -->
                          <!-- <tr>
                              <td class="text-center" rowspan="3">Бинонинг ёши</td>
                              <td>
                                  Бино курилган йил
                              </td>
                              <td class="text-center">{{realEstate.newComparison.builtYear}}</td>
                              <td v-for="(analog,index) in realEstate.newComparison.analogs" :key="index" class="text-center">
                                  {{analog.builtYear}}
                              </td>
                          </tr>
                          <tr>
                              <td>Тузатиш</td>
                              <td></td>
                              <td v-for="(analog,index) in realEstate.newComparison.analogs" :key="index" class="text-center">
                                  {{analog.fix.age | currency('', 4, { thousandsSeparator: ' ' })}}
                              </td>
                          </tr>
                          <tr>
                              <td>1 м.кв учун тузатишдан кейинги киймат</td>
                              <td></td>
                              <td v-for="(analog,index) in realEstate.newComparison.analogs" :key="index" class="text-right">
                                  {{analog.price.ageFixed | currency('', 2, { thousandsSeparator: ' ' })}}
                              </td>
                          </tr> -->
                          <!-- end -->
                          <!-- Бино ҳолати бўйича -->
                          <tr>
                              <td class="text-center" rowspan="4">Бино ҳолати бўйича</td>
                              <td>
                                  Таъмир холати
                              </td>
                              <td class="text-center">
                                  <span v-if="realEstate.newComparison.state && repairConditions && repairConditions.length > 0">
                                      {{getRepairNameByCode(realEstate.newComparison.state)}}
                                  </span>
                              </td>
                              <td v-for="(analog,index) in realEstate.newComparison.analogs" :key="index" class="text-center">
                                  <span v-if="analog.state && repairConditions && repairConditions.length > 0">
                                      {{getRepairNameByCode(analog.state)}}
                                  </span>
                              </td>
                          </tr>
                          <tr>
                              <td></td>
                              <td class="text-center">{{realEstate.newComparison.stateCoefficient}} %</td>
                              <td v-for="(analog,index) in realEstate.newComparison.analogs" :key="index" class="text-center">
                                  {{analog.stateCoefficient}} %
                              </td>
                          </tr>
                          <tr>
                              <td>Тузатиш</td>
                              <td></td>
                              <td v-for="(analog,index) in realEstate.newComparison.analogs" :key="index" class="text-center">
                                  {{analog.fix.state | currency('', 3, { thousandsSeparator: ' ' })}}
                              </td>
                          </tr>
                          <tr>
                              <td>1 м.кв учун тузатишдан кейинги киймат</td>
                              <td></td>
                              <td v-for="(analog,index) in realEstate.newComparison.analogs" :key="index" class="text-right">
                                  {{analog.price.stateFixed | currency('', 2, { thousandsSeparator: ' ' })}}
                              </td>
                          </tr>
                          <!-- end -->
                          <template v-if="realEstate.newComparison.coefficient && realEstate.newComparison.coefficient.housingType">
                            <!-- Нотурар жой тури -->
                            <tr>
                              <td class="text-center" rowspan="5">Қурилган даври</td>
                              <td>
                                {{realEstate.category === 'Residential' ? "Турар жой тури" : "Нотурар жой тури"}}
                              </td>
                              <td class="text-center">
                                {{getReferenceByCode('HousingType', realEstate.data.values['housing_type'].code)}}
                              </td>
                              <td v-for="(analog,index) in realEstate.newComparison.analogs" :key="index" class="text-center">
                                {{analog.housingType}}
                              </td>
                            </tr>
                            <tr>
                              <td>Қурилган йили</td>
                              <td class="text-center">
                                {{realEstate.builtYear}}
                              </td>
                              <td v-for="(analog,index) in realEstate.newComparison.analogs" :key="index" class="text-center">
                                {{analog.builtYear}}
                              </td>
                            </tr>
                            <tr>
                              <td></td>
                              <td class="text-center">{{realEstate.newComparison.coefficient.housingType}}</td>
                              <td v-for="(analog,index) in realEstate.newComparison.analogs" :key="index" class="text-center">
                                {{analog.coefficient.housingType}}
                              </td>
                            </tr>
                            <tr>
                              <td>Тузатиш</td>
                              <td></td>
                              <td v-for="(analog,index) in realEstate.newComparison.analogs" :key="index" class="text-center">
                                {{analog.fix.housingType | currency('', 3, { thousandsSeparator: ' ' })}}
                              </td>
                            </tr>
                            <tr>
                              <td>1 м.кв учун тузатишдан кейинги киймат</td>
                              <td></td>
                              <td v-for="(analog,index) in realEstate.newComparison.analogs" :key="index" class="text-right">
                                {{analog.price.housingTypeFixed | currency('', 2, { thousandsSeparator: ' ' })}}
                              </td>
                            </tr>
                            <!-- end -->
                          </template>
                          <!-- Функцианал жихатдан фойдалилиги -->
                          <tr>
                              <td class="text-center" rowspan="4">Функцианал жихатдан фойдалилиги</td>
                              <td>
                                  Объект номи
                              </td>
                              <td class="text-center">{{realEstate.newComparison.buildingType.name}}</td>
                              <td v-for="(analog,index) in realEstate.newComparison.analogs" :key="index" class="text-center">
                                  <span v-if="buildingTypes && buildingTypes.length > 0">{{getBuildingType(analog.categoryCode)[0].name}}</span>
                              </td>
                          </tr>
                          <tr>
                              <td></td>
                              <td class="text-center">{{realEstate.newComparison.categoryCoefficient}}%</td>
                              <td v-for="(analog,index) in realEstate.newComparison.analogs" :key="index" class="text-center">
                                  {{analog.categoryCoefficient}}%
                              </td>
                          </tr>
                          <tr>
                              <td>Тузатиш</td>
                              <td></td>
                              <td v-for="(analog,index) in realEstate.newComparison.analogs" :key="index" class="text-center">
                                  {{analog.fix.category}} %
                              </td>
                          </tr>
                          <tr>
                              <td>1 м.кв учун тузатишдан кейинги киймат</td>
                              <td></td>
                              <td v-for="(analog,index) in realEstate.newComparison.analogs" :key="index" class="text-right">
                                  {{analog.price.categoryFixed | currency('', 2, { thousandsSeparator: ' ' })}}
                              </td>
                          </tr>
                          <!-- end -->
                          <template v-if="realEstate.newComparison.coefficient && realEstate.newComparison.coefficient.basement">
                            <!-- Ертўла тури -->
                            <tr>
                              <td class="text-center" rowspan="4">Ертўла тури</td>
                              <td>
                                Ер тўла мавжудлиги
                              </td>
                              <td class="text-center">
                                {{getReferenceByCode('BasementBuildingType', realEstate.data.values['basement_building_type'].code)}}
                              </td>
                              <td v-for="(analog,index) in realEstate.newComparison.analogs" :key="index" class="text-center">
                                {{analog.basement}}
                              </td>
                            </tr>
                            <tr>
                              <td></td>
                              <td class="text-center">{{realEstate.newComparison.coefficient.basement}}</td>
                              <td v-for="(analog,index) in realEstate.newComparison.analogs" :key="index" class="text-center">
                                {{analog.coefficient.basement}}
                              </td>
                            </tr>
                            <tr>
                              <td>Тузатиш</td>
                              <td></td>
                              <td v-for="(analog,index) in realEstate.newComparison.analogs" :key="index" class="text-center">
                                {{analog.fix.basement | currency('', 3, { thousandsSeparator: ' ' })}}
                              </td>
                            </tr>
                            <tr>
                              <td>1 м.кв учун тузатишдан кейинги киймат</td>
                              <td></td>
                              <td v-for="(analog,index) in realEstate.newComparison.analogs" :key="index" class="text-right">
                                {{analog.price.basementFixed | currency('', 2, { thousandsSeparator: ' ' })}}
                              </td>
                            </tr>
                            <!-- end -->
                          </template>
                          <!-- Ер участкасининг хажми ва унда курилган иморатлар майдони -->
                          <template v-if="!(realEstate.newComparison.buildingType.code === 'RESIDENTIAL_MULTI_STOREY')">
                              <tr>
                                  <td class="text-center" rowspan="7">
                                      Ер участкасининг хажми ва унда
                                      <br />
                                      курилган иморатлар майдони
                                  </td>
                                  <td>1 м2 ер майдонинг нархи </td>
                                  <td class="text-right">{{realEstate.newComparison.landPerAreaUnitPrice | currency('', 2, { thousandsSeparator: ' ' })}}</td>
                                  <td v-for="(analog,index) in realEstate.newComparison.analogs" :key="index" class="text-right">
                                      {{realEstate.newComparison.landPerAreaUnitPrice | currency('', 2, { thousandsSeparator: ' ' })}}
                                  </td>
                              </tr>
                              <tr>
                                  <td>Умумий ер майдони м2</td>
                                  <td class="text-center">{{realEstate.newComparison.totalArea}}</td>
                                  <td v-for="(analog,index) in realEstate.newComparison.analogs" :key="index" class="text-center">
                                      {{analog.totalArea}}
                                  </td>
                              </tr>
                              <!--1 м2 ер майдонинг курилиш билан банд бўлган кисми-->
                              <tr>
                                  <td>Умумий ер майдонининг катта кичиклигига тузатиш</td>
                                  <td class="text-center">{{realEstate.newComparison.perAreaUnitCoefficient}}</td>
                                  <td v-for="(analog,index) in realEstate.newComparison.analogs" :key="index" class="text-center">
                                      {{analog.fix.perAreaUnitCoefficient | currency('', 2, { thousandsSeparator: ' ' })}}%
                                  </td>
                              </tr>
                              <!--Курилиш билан банд кисмига тузатиш-->
                              <tr>
                                  <td>Тузатиш фоизда</td>
                                  <td></td>
                                  <td v-for="(analog,index) in realEstate.newComparison.analogs" :key="index" class="text-center">
                                      {{analog.fix.totalLandArea }}%
                                  </td>
                              </tr>
                              <!--1 м.кв ернинг нархига тузатиш-->
                              <tr>
                                  <td>Тузатиш сўмда</td>
                                  <td class="text-center"></td>
                                  <td v-for="(analog,index) in realEstate.newComparison.analogs" :key="index" class="text-right">
                                      {{analog.price.landAreaFixed | currency('', 2, { thousandsSeparator: ' ' })}}
                                  </td>
                              </tr>
                              <tr>
                                  <td>1 м.кв Ер майдон тузатишдан кейинги қиймати</td>
                                  <td class="text-center"></td>
                                  <td v-for="(analog,index) in realEstate.newComparison.analogs" :key="index" class="text-right">
                                      {{analog.price.perAreaUnitCoefficient | currency('', 2, { thousandsSeparator: ' ' })}}
                                  </td>
                              </tr>
                              <tr>
                                  <td style="font-weight: bold">1 м.кв умумий майдон учун тузатишдан кейинги киймат</td>
                                  <td></td>
                                  <td v-for="(analog,index) in realEstate.newComparison.analogs" :key="index" class="text-right">
                                      {{analog.price.landPerAreaUnitTotal | currency('', 2, { thousandsSeparator: ' ' })}}
                                  </td>
                              </tr>
                          </template>
                          <!-- end -->
                          <!-- Жалб килувчанлиги -->
                          <!--<tr>-->
                              <!--<td class="text-center" rowspan="4">Жалб килувчанлиги</td>-->
                              <!--<td>-->
                                  <!--Жойлашуви-->
                              <!--</td>-->
                              <!--<td class="text-center">{{realEstate.newComparison.specialComfort}}</td>-->
                              <!--<td v-for="(analog,index) in realEstate.newComparison.analogs" :key="index" class="text-center">-->
                                  <!--{{analog.specialComfort}}-->
                              <!--</td>-->
                          <!--</tr>-->
                          <!--<tr>-->
                              <!--<td></td>-->
                              <!--<td class="text-center">{{realEstate.newComparison.specialComfortCoefficient}} %</td>-->
                              <!--<td v-for="(analog,index) in realEstate.newComparison.analogs" :key="index" class="text-center">-->
                                  <!--{{analog.specialComfortCoefficient}} %-->
                              <!--</td>-->
                          <!--</tr>-->
                          <!--<tr>-->
                              <!--<td>Тузатиш</td>-->
                              <!--<td></td>-->
                              <!--<td v-for="(analog,index) in realEstate.newComparison.analogs" :key="index" class="text-center">-->
                                  <!--{{analog.fix.specialComfort}} %-->
                              <!--</td>-->
                          <!--</tr>-->
                          <!--<tr>-->
                              <!--<td>1 м.кв учун тузатишдан кейинги киймат</td>-->
                              <!--<td></td>-->
                              <!--<td v-for="(analog,index) in realEstate.newComparison.analogs" :key="index" class="text-right">-->
                                  <!--{{analog.price.specialComfort | currency('', 2, { thousandsSeparator: ' ' })}}-->
                              <!--</td>-->
                          <!--</tr>-->
                          <!-- end -->
                          <!-- Курилиш сифати -->
                          <tr>
                              <td class="text-center" rowspan="3">Курилиш сифати</td>
                              <td>
                                  Курилиш тугалланганлиги
                              </td>
                              <td class="text-center">{{realEstate.newComparison.constructionCompletion}}%</td>
                              <td v-for="(analog,index) in realEstate.newComparison.analogs" :key="index" class="text-center">
                                  {{analog.constructionCompletion}} %
                              </td>
                          </tr>
                          <tr>
                              <td>Тузатиш</td>
                              <td></td>
                              <td v-for="(analog,index) in realEstate.newComparison.analogs" :key="index" class="text-center">
                                  {{analog.fix.constructionCompletion}} %
                              </td>
                          </tr>
                          <tr>
                              <td>1 м.кв учун тузатишдан кейинги киймат</td>
                              <td></td>
                              <td v-for="(analog,index) in realEstate.newComparison.analogs" :key="index" class="text-right">
                                  {{analog.price.constructionCompletionFixed | currency('', 2, { thousandsSeparator: ' ' })}}
                              </td>
                          </tr>
                          <!-- end -->
                          <!-- Ободонлаштирилганлиги -->
                          <tr>
                              <td class="text-center" rowspan="3">Ободонлаштирилганлиги</td>
                              <td>
                                  Холати
                              </td>
                              <td class="text-center">Ободонлаштирилган</td>
                              <td v-for="(analog,index) in realEstate.newComparison.analogs" :key="index" class="text-center">
                                  Ободонлаштирилган
                              </td>
                          </tr>
                          <tr>
                              <td>Тузатиш</td>
                              <td></td>
                              <td v-for="(analog,index) in realEstate.newComparison.analogs" :key="index" class="text-center">
                                  1
                              </td>
                          </tr>
                          <tr>
                              <td>1 м.кв учун тузатишдан кейинги киймат</td>
                              <td></td>
                              <td v-for="(analog,index) in realEstate.newComparison.analogs" :key="index" class="text-right">
                                  {{analog.price.constructionCompletionFixed | currency('', 2, { thousandsSeparator: ' ' })}}
                              </td>
                          </tr>
                          <!-- end -->
                          <!-- Қулайликлари -->
                          <tr>
                              <td class="text-center" rowspan="4">Қулайликлари</td>
                              <td>
                                  Мухандислик камуникациялари
                              </td>
                              <td class="text-center">{{realEstate.newComparison.communications}}</td>
                              <td v-for="(analog,index) in realEstate.newComparison.analogs" :key="index" class="text-center">
                                  {{analog.communications}}
                              </td>
                          </tr>
                          <tr>
                              <td></td>
                              <td class="text-center">{{realEstate.newComparison.communicationCoefficient}} %</td>
                              <td v-for="(analog,index) in realEstate.newComparison.analogs" :key="index" class="text-center">
                                  {{analog.communicationCoefficient}} %
                              </td>
                          </tr>
                          <tr>
                              <td>Тузатиш</td>
                              <td></td>
                              <td v-for="(analog,index) in realEstate.newComparison.analogs" :key="index" class="text-center">
                                  {{analog.fix.communicationCoefficient}}
                              </td>
                          </tr>
                          <tr>
                              <td>1 м.кв учун тузатишдан кейинги киймат</td>
                              <td></td>
                              <td v-for="(analog,index) in realEstate.newComparison.analogs" :key="index" class="text-right">
                                  {{analog.price.communicationCoefficient | currency('', 2, { thousandsSeparator: ' ' })}}
                              </td>
                          </tr>
                          <!-- end -->
                          <!-- Қаватлилиги ва кавати -->
                          <template v-if="realEstate.newComparison.floorCoefficient">
                            <tr>
                              <td class="text-center" rowspan="4">Қаватлилиги</td>
                              <td>Қавати</td>
                              <td class="text-center">{{realEstate.newComparison.floor}}</td>
                              <td v-for="(analog,index) in realEstate.newComparison.analogs" :key="index" class="text-center">
                                {{analog.floor}}
                              </td>
                            </tr>
                            <tr>
                              <td></td>
                              <td class="text-center">{{realEstate.newComparison.floorCoefficient | currency('', 3, { thousandsSeparator: ' ' })}} </td>
                              <td v-for="(analog,index) in realEstate.newComparison.analogs" :key="index" class="text-center">
                                {{analog.floorCoefficient}}
                              </td>
                            </tr>
                            <tr>
                              <td>Тузатиш</td>
                              <td></td>
                              <td v-for="(analog,index) in realEstate.newComparison.analogs" :key="index" class="text-center">
                                {{analog.fix.floor | currency('', 3, { thousandsSeparator: ' ' })}}
                              </td>
                            </tr>
                            <tr>
                              <td>1 м.кв учун тузатишдан кейинги киймат</td>
                              <td></td>
                              <td v-for="(analog,index) in realEstate.newComparison.analogs" :key="index" class="text-right">
                                {{analog.price.floorFixed | currency('', 2, { thousandsSeparator: ' ' })}}
                              </td>
                            </tr>
                          </template>
                          <!-- end -->
                          <!-- Лифт мавжудлиги -->
                          <template v-if="realEstate.newComparison.coefficient && realEstate.newComparison.coefficient.elevator">
                            <tr>
                              <td class="text-center" rowspan="4">Лифт мавжудлиги</td>
                              <td>Лифт</td>
                              <td class="text-center">{{realEstate.newComparison.elevator}}</td>
                              <td v-for="(analog,index) in realEstate.newComparison.analogs" :key="index" class="text-center">
                                {{analog.elevator}}
                              </td>
                            </tr>
                            <tr>
                              <td></td>
                              <td class="text-center">{{realEstate.newComparison.coefficient.elevator}} </td>
                              <td v-for="(analog,index) in realEstate.newComparison.analogs" :key="index" class="text-center">
                                {{analog.coefficient.elevator}}
                              </td>
                            </tr>
                            <tr>
                              <td>Тузатиш</td>
                              <td></td>
                              <td v-for="(analog,index) in realEstate.newComparison.analogs" :key="index" class="text-center">
                                {{analog.fix.elevator}}
                              </td>
                            </tr>
                            <tr>
                              <td>1 м.кв учун тузатишдан кейинги киймат</td>
                              <td></td>
                              <td v-for="(analog,index) in realEstate.newComparison.analogs" :key="index" class="text-right">
                                {{analog.price.elevatorFixed | currency('', 2, { thousandsSeparator: ' ' })}}
                              </td>
                            </tr>
                          </template>
                          <!-- end -->
                          <!-- Участка экалогияси -->
                          <tr>
                              <td class="text-center" rowspan="3">Участка экалогияси</td>
                              <td>
                                  Холати
                              </td>
                              <td class="text-center">Маълумот мавжуд эмас</td>
                              <td v-for="(analog,index) in realEstate.newComparison.analogs" :key="index" class="text-center">
                                  Маълумот мавжуд эмас
                              </td>
                          </tr>
                          <tr>
                              <td>Тузатиш</td>
                              <td></td>
                              <td v-for="(analog,index) in realEstate.newComparison.analogs" :key="index" class="text-center">
                                  1
                              </td>
                          </tr>
                          <tr>
                              <td>1 м.кв учун тузатишдан кейинги киймат</td>
                              <td></td>
                              <td v-for="(analog,index) in realEstate.newComparison.analogs" :key="index" class="text-right">
                                  {{analog.price.elevatorFixed ? analog.price.elevatorFixed : analog.price.communicationCoefficient | currency('', 2, { thousandsSeparator: ' ' })}}
                              </td>
                          </tr>
                          <!-- end -->
                          <!-- Объектнинг даромадига таъсир киладиган тавсифлар -->
                          <tr>
                              <td class="text-center" rowspan="3">Объектнинг даромадига таъсир киладиган тавсифлар</td>
                              <td>
                                  Фойдаланиш харажатлари
                              </td>
                              <td class="text-center">Маълумот мавжуд эмас</td>
                              <td v-for="(analog,index) in realEstate.newComparison.analogs" :key="index" class="text-center">
                                  Маълумот мавжуд эмас
                              </td>
                          </tr>
                          <tr>
                              <td>Тузатиш</td>
                              <td></td>
                              <td v-for="(analog,index) in realEstate.newComparison.analogs" :key="index" class="text-center">
                                  1
                              </td>
                          </tr>
                          <tr>
                              <td>1 м.кв учун тузатишдан кейинги киймат</td>
                              <td></td>
                              <td v-for="(analog,index) in realEstate.newComparison.analogs" :key="index" class="text-right">
                                {{analog.price.elevatorFixed ? analog.price.elevatorFixed : analog.price.communicationCoefficient | currency('', 2, { thousandsSeparator: ' ' })}}
                              </td>
                          </tr>
                          <!-- end -->
                          <!-- Бошкариш сифати -->
                          <tr>
                              <td class="text-center" rowspan="3">Бошкариш сифати</td>
                              <td>
                                  Холат
                              </td>
                              <td class="text-center">Маълумот мавжуд эмас</td>
                              <td v-for="(analog,index) in realEstate.newComparison.analogs" :key="index" class="text-center">
                                  Маълумот мавжуд эмас
                              </td>
                          </tr>
                          <tr>
                              <td>Тузатиш</td>
                              <td></td>
                              <td v-for="(analog,index) in realEstate.newComparison.analogs" :key="index" class="text-center">
                                  1
                              </td>
                          </tr>
                          <tr>
                              <td>1 м.кв учун тузатишдан кейинги киймат</td>
                              <td></td>
                              <td v-for="(analog,index) in realEstate.newComparison.analogs" :key="index" class="text-right">
                                {{analog.price.elevatorFixed ? analog.price.elevatorFixed : analog.price.communicationCoefficient | currency('', 2, { thousandsSeparator: ' ' })}}
                              </td>
                          </tr>
                          <!-- end -->
                          <!-- Ижарачиларнинг ишончлилиги -->
                          <tr>
                              <td class="text-center" rowspan="3">Ижарачиларнинг ишончлилиги</td>
                              <td>
                                  Холат
                              </td>
                              <td class="text-center">Маълумот мавжуд эмас</td>
                              <td v-for="(analog,index) in realEstate.newComparison.analogs" :key="index" class="text-center">
                                  Маълумот мавжуд эмас
                              </td>
                          </tr>
                          <tr>
                              <td>Тузатиш</td>
                              <td></td>
                              <td v-for="(analog,index) in realEstate.newComparison.analogs" :key="index" class="text-center">
                                  1
                              </td>
                          </tr>
                          <tr>
                              <td>1 м.кв учун тузатишдан кейинги киймат</td>
                              <td></td>
                              <td v-for="(analog,index) in realEstate.newComparison.analogs" :key="index" class="text-right">
                                {{analog.price.elevatorFixed ? analog.price.elevatorFixed : analog.price.communicationCoefficient | currency('', 2, { thousandsSeparator: ' ' })}}
                              </td>
                          </tr>
                          <!-- end -->
                          <!-- Ижара нархидаги чегирмалар -->
                          <tr>
                              <td class="text-center" rowspan="3">Ижара нархидаги чегирмалар</td>
                              <td>
                                  Холат
                              </td>
                              <td class="text-center">Маълумот мавжуд эмас</td>
                              <td v-for="(analog,index) in realEstate.newComparison.analogs" :key="index" class="text-center">
                                  Маълумот мавжуд эмас
                              </td>
                          </tr>
                          <tr>
                              <td>Тузатиш</td>
                              <td></td>
                              <td v-for="(analog,index) in realEstate.newComparison.analogs" :key="index" class="text-center">
                                  1
                              </td>
                          </tr>
                          <tr>
                              <td>1 м.кв учун тузатишдан кейинги киймат</td>
                              <td></td>
                              <td v-for="(analog,index) in realEstate.newComparison.analogs" :key="index" class="text-right">
                                {{analog.price.elevatorFixed ? analog.price.elevatorFixed : analog.price.communicationCoefficient | currency('', 2, { thousandsSeparator: ' ' })}}
                              </td>
                          </tr>
                          <!-- end -->
                          <!-- Ижара шартномаси шартлари -->
                          <tr>
                              <td class="text-center" rowspan="3">Ижара шартномаси шартлари</td>
                              <td>
                                  Холат
                              </td>
                              <td class="text-center">Маълумот мавжуд эмас</td>
                              <td v-for="(analog,index) in realEstate.newComparison.analogs" :key="index" class="text-center">
                                  Маълумот мавжуд эмас
                              </td>
                          </tr>
                          <tr>
                              <td>Тузатиш</td>
                              <td></td>
                              <td v-for="(analog,index) in realEstate.newComparison.analogs" :key="index" class="text-center">
                                  1
                              </td>
                          </tr>
                          <tr>
                              <td>1 м.кв учун тузатишдан кейинги киймат</td>
                              <td></td>
                              <td v-for="(analog,index) in realEstate.newComparison.analogs" :key="index" class="text-right">
                                {{analog.price.elevatorFixed ? analog.price.elevatorFixed : analog.price.communicationCoefficient | currency('', 2, { thousandsSeparator: ' ' })}}
                              </td>
                          </tr>
                          <!-- end -->
                          <!-- Ижара шартномаси тугайдиган муддат -->
                          <tr>
                              <td class="text-center" rowspan="3">Ижара шартномаси тугайдиган муддат</td>
                              <td>
                                  Холат
                              </td>
                              <td class="text-center">Маълумот мавжуд эмас</td>
                              <td v-for="(analog,index) in realEstate.newComparison.analogs" :key="index" class="text-center">
                                  Маълумот мавжуд эмас
                              </td>
                          </tr>
                          <tr>
                              <td>Тузатиш</td>
                              <td></td>
                              <td v-for="(analog,index) in realEstate.newComparison.analogs" :key="index" class="text-center">
                                  1
                              </td>
                          </tr>
                          <tr>
                              <td>1 м.кв учун тузатишдан кейинги киймат</td>
                              <td></td>
                              <td v-for="(analog,index) in realEstate.newComparison.analogs" :key="index" class="text-right">
                                 {{analog.price.elevatorFixed ? analog.price.elevatorFixed : analog.price.communicationCoefficient | currency('', 2, { thousandsSeparator: ' ' })}}
                              </td>
                          </tr>
                          <!-- end -->
                          <!-- Ижарани узайтириш -->
                          <tr>
                              <td class="text-center" rowspan="3">Ижарани узайтириш</td>
                              <td>
                                  Холат
                              </td>
                              <td class="text-center">Маълумот мавжуд эмас</td>
                              <td v-for="(analog,index) in realEstate.newComparison.analogs" :key="index" class="text-center">
                                  Маълумот мавжуд эмас
                              </td>
                          </tr>
                          <tr>
                              <td>Тузатиш</td>
                              <td></td>
                              <td v-for="(analog,index) in realEstate.newComparison.analogs" :key="index" class="text-center">
                                  1
                              </td>
                          </tr>
                          <tr>
                              <td>1 м.кв учун тузатишдан кейинги киймат</td>
                              <td></td>
                              <td v-for="(analog,index) in realEstate.newComparison.analogs" :key="index" class="text-right">
                                 {{analog.price.elevatorFixed ? analog.price.elevatorFixed : analog.price.communicationCoefficient | currency('', 2, { thousandsSeparator: ' ' })}}
                              </td>
                          </tr>
                          <!-- end -->
                          <!-- Энг макбул ва энг самарали фойдаланиш шартларига объектнинг мувофиклиги -->
                          <tr>
                              <td class="text-center" rowspan="3">
                                  Энг макбул ва энг самарали фойдаланиш
                                  <br />
                                  шартларига объектнинг мувофиклиги
                              </td>
                              <td>
                                  Объект мувофиклиги
                              </td>
                              <td class="text-center">
                                  <!--{{realEstate.newComparison.buildingType.name}}-->
                                  Жорий фаолият турида самаралироқ
                              </td>
                              <td v-for="(analog,index) in realEstate.newComparison.analogs" :key="index" class="text-center">
                                  <!--{{realEstate.newComparison.buildingType.name}}-->
                                  Жорий фаолият турида самаралироқ
                              </td>
                          </tr>
                          <tr>
                              <td>Тузатиш</td>
                              <td></td>
                              <td v-for="(analog,index) in realEstate.newComparison.analogs" :key="index" class="text-center">
                                  1
                              </td>
                          </tr>
                          <tr>
                              <td>1 м.кв учун тузатишдан кейинги киймат</td>
                              <td></td>
                              <td v-for="(analog,index) in realEstate.newComparison.analogs" :key="index" class="text-right">
                                 {{analog.price.elevatorFixed ? analog.price.elevatorFixed : analog.price.communicationCoefficient | currency('', 2, { thousandsSeparator: ' ' })}}
                              </td>
                          </tr>
                          <!-- end -->
                          <!-- Кўчмас мулк хисобланмайдиган компанентлар -->
                          <tr>
                              <td class="text-center" rowspan="3">Кўчмас мулк хисобланмайдиган компанентлар</td>
                              <td>
                                  Холат
                              </td>
                              <td class="text-center">Маълумот мавжуд эмас</td>
                              <td v-for="(analog,index) in realEstate.newComparison.analogs" :key="index" class="text-center">
                                  Маълумот мавжуд эмас
                              </td>
                          </tr>
                          <tr>
                              <td>Тузатиш</td>
                              <td></td>
                              <td v-for="(analog,index) in realEstate.newComparison.analogs" :key="index" class="text-center">
                                  1
                              </td>
                          </tr>
                          <tr>
                              <td>1 м.кв учун тузатишдан кейинги киймат</td>
                              <td></td>
                              <td v-for="(analog,index) in realEstate.newComparison.analogs" :key="index" class="text-right">
                                 {{analog.price.elevatorFixed ? analog.price.elevatorFixed : analog.price.communicationCoefficient | currency('', 2, { thousandsSeparator: ' ' })}}
                              </td>
                          </tr>
                          <!-- end -->
                          <tr>
                              <td class="text-center"><b>Тузатишлар сони</b></td>
                              <td></td>
                              <td></td>
                              <td v-for="(analog,index) in realEstate.newComparison.analogs" :key="index" class="text-center">
                                  {{analog.totalFixes}}
                              </td>
                          </tr>
                          <tr>
                              <td class="text-center"><b>Коффициент улушлари</b></td>
                              <td></td>
                              <td></td>
                              <td v-for="(analog,index) in realEstate.newComparison.analogs" :key="index" class="text-center">
                                  {{analog.totalFixesCoefficient}} %
                              </td>
                          </tr>
                        </template>
                          <tr>
                              <td class="text-center"><b>Тузатишларни киритгандан кейинги</b>
                                  <br/><b>улушларни хисобга олгандаги бахоси</b></td>
                              <td></td>
                              <td></td>
                              <td v-for="(analog,index) in realEstate.newComparison.analogs" :key="index" class="text-center">
                                  {{analog.totalPrice | currency('', 2, { thousandsSeparator: ' ' })}}
                              </td>
                          </tr>
                          <tr>
                              <td class="text-center"><b>Баҳолаш объектининг 1м2 учун якуний қиймати</b></td>
                              <td></td>
                              <td colspan="4" class="text-right">
                                  <b>{{realEstate.newComparison.totalPrice | currency('', 2, { thousandsSeparator: ' ' })}} сўм</b>
                              </td>
                          </tr>
                          <template v-if="realEstate.newComparison.buildingType.code !== 'RESIDENTIAL_MULTI_STOREY'">
                              <tr>
                                  <td class="text-center"><b>1м2 ер участкасининг қиймати</b></td>
                                  <td></td>
                                  <td colspan="4" class="text-right">
                                      <b>{{realEstate.newComparison.landPerAreaUnitPrice | currency('', 2, { thousandsSeparator: ' ' })}}</b>
                                  </td>
                              </tr>
                          </template>
                          <tr>
                              <td class="text-center"><b>Баҳолаш объектининг умумий майдони кв.м</b></td>
                              <td></td>
                              <td colspan="4" class="text-right">
                                  <b v-if="realEstate.newComparison.buildingType.code === 'RESIDENTIAL_MULTI_STOREY'">{{realEstate.newComparison.totalArea }}</b>
                                  <b v-else>
                                    {{realEstate.hasTotalArea ? realEstate.newComparison.evlTotalArea : realEstate.newComparison.usefulArea}}
                                  </b>
                              </td>
                          </tr>
                          <tr>
                              <td class="text-center"><b>Баҳолаш объектининг якуний қиймати</b></td>
                              <td></td>
                              <td colspan="4" class="text-right">
                                  <b>{{realEstate.newComparison.finalTotalPrice | currency('', 2, { thousandsSeparator: ' ' })}} сўм</b>
                              </td>
                          </tr>
                          <template v-if="realEstate.newComparison.buildingType.code !== 'RESIDENTIAL_MULTI_STOREY'">
                              <tr>
                                  <td class="text-center"><b>Ер участкаси умумий майдони кв.м</b></td>
                                  <td></td>
                                  <td colspan="4" class="text-right">
                                      <b>{{realEstate.newComparison.totalArea}}</b>
                                  </td>
                              </tr>
                              <tr>
                                  <td class="text-center"><b>Ер участкаси қиймати</b></td>
                                  <td></td>
                                  <td colspan="4" class="text-right">
                                      <b>{{ realEstate.newComparison.finalLandTotalPrice | currency('', 2, { thousandsSeparator: ' ' }) }}</b>
                                  </td>
                              </tr>
                          </template>
                          <template v-if="realEstate.newComparison.comparativeCostObjects.length > 0">
                              <template>
                                  <tr class="bg-color" @click="isShowCost=!isShowCost">
                                      <td class="font-weight-bold"  v-tooltip="'Қўшимча иншоатлар'">
                                          Қўшимча иншоатлар 1 кв қиймати ...
                                      </td>
                                      <td></td>
                                      <td colspan="4" class="text-right font-weight-bold">{{calculatedComparativeCostObjectTotal.calculated.amount | currency('', 2, { thousandsSeparator: ' ' })}} сўм</td>
                                  </tr>
                                  <tr>
                                      <td class="font-weight-bold">Қўшимча иншоатлар умумий майдони</td>
                                      <td></td>
                                      <td colspan="4" class="text-right font-weight-bold">{{calculatedComparativeCostObjectTotal.calculated.area | currency('', 2, { thousandsSeparator: ' ' })}} кв.м</td>
                                  </tr>
                                  <tr>
                                      <td class="font-weight-bold">Қўшимча иншоатлар умумий қиймати</td>
                                      <td></td>
                                      <td colspan="4" class="text-right font-weight-bold">{{calculatedComparativeCostObjectTotal.calculated.totalAmount | currency('', 2, { thousandsSeparator: ' ' })}} сўм</td>
                                  </tr>
                              </template>
                              <template v-if="isShowCost">
                                  <template v-for="(object, index) in realEstate.newComparison.comparativeCostObjects">
                                      <tr :key="'a' + index" class="bg-color">
                                          <td class="font-weight-bold">1 кв {{object.name}} қиймати</td>
                                          <td></td>
                                          <td colspan="4" class="text-right">{{object.amount | currency('', 2, { thousandsSeparator: ' ' })}} сўм</td>
                                      </tr>
                                      <tr :key="'b' + index">
                                          <td>{{object.name}} умумий майдони</td>
                                          <td></td>
                                          <td colspan="4" class="text-right">{{object.area | currency('', 2, { thousandsSeparator: ' ' })}} кв.м</td>
                                      </tr>
                                      <tr :key="'c' + index">
                                          <td>{{object.name}} умумий қиймати</td>
                                          <td></td>
                                          <td colspan="4" class="text-right">{{object.totalAmount | currency('', 2, { thousandsSeparator: ' ' })}} сўм</td>
                                      </tr>
                                  </template>
                              </template>
                          </template>
                          <tr>
                              <td class="text-center"><b>Бахолаш объекти умумий қиймати</b></td>
                              <td></td>
                              <td colspan="4" class="text-right">
                                  <b>{{realEstate.newComparison.calculatedTotalPrice | currency('', 2, { thousandsSeparator: ' ' }) }} сўм</b>
                              </td>
                          </tr>
                      </table>
                    </div>
                </div>
            </div>
        </div>
        <div class="row" v-else>
            <div class="col-12">
                <div class="text-center">
                    <span class="no-data mt-5 mb-5">{{$t("messages.list.empty")}}</span>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import AdvancedFilter from '@/shared/filters/advancedFilter'
    import {mapState} from "vuex";
    export default {
        name: "NewRealEstateComparison",
        props: {
            realEstate: Object,
            references: Object
        },
        data() {
            return {
                filterBuildingType: new AdvancedFilter(),
                buildingTypes: [],
                repairConditions: [],
                analogs: [],
                isShowCost: false
            }
        },
        methods: {
            init() {
                const vm = this;
                const id = this.$route.params.id;
                this.filterBuildingType.onlyParentLookUp = true

                const promises = [
                    this.$http.post('building-type/list', this.filterBuildingType)
                ];

                if (this.canSelect && id && id > 0) {
                    promises.push(this.$http.get(`admin/new-real-estate/search-analog/${id}`));
                }

                Promise.all(promises).then(function (values) {
                    const buildingTypeData = values[0].data;
                    vm.buildingTypes = buildingTypeData.data;

                    if (values.length >= 2) {
                        const analogData = values[1].data;
                        if(analogData) {
                          vm.analogs = analogData.data.map((analog) => {
                            analog.name = analog.id + "#" + analog.name;
                            return analog;
                          });
                        }

                    }
                });
                this.initRepair();
            },
            getBuildingType(code) {
                return this.buildingTypes.filter(type => type.code === code).map(type =>({code: type.code, name:type.name}));
            },
            initRepair() {
                this.repairConditions = [];
                this.$http.get('uy-joy-api/repair-conditions')
                    .then(res => {
                        this.repairConditions = res.data;
                    }, err => {
                        console.log(err)
                    })
            },
            getRepairNameByCode(code) {
                const repairConditions = this.repairConditions.filter(r => r.code === code);
                if (repairConditions && repairConditions.length > 0) {
                    return repairConditions[0].displayName;
                }
                return '';
            },
            getReferenceByCode(code, childCode) {
              const references = this.$props.references
              if (references && references.hasOwnProperty(code)) {
                const fieldReferences = references[code];
                const results = fieldReferences.filter((ref) => {
                  return ref.code === childCode
                });
                return results.length > 0 ? results[0].name : null;
              }
              return '';
            }
        },
        computed: {
            ...mapState(['profile']),
            isValidData() {
                return this.realEstate.approachComparative && this.realEstate.newComparison &&
                    this.realEstate.newComparison.analogs && this.realEstate.newComparison.analogs.length > 2
            },
            isMultiStorey() {
                return this.realEstate.newComparison.buildingType.code === 'RESIDENTIAL_MULTI_STOREY'
            },
            isNotRegionFixCalculated() {
                return this.realEstate.newComparison && !this.realEstate.newComparison.regionFixCalculated
            },
            isRegionFixCalculated() {
              return this.realEstate.newComparison && this.realEstate.newComparison.regionFixCalculated && this.realEstate.newComparison.regionFixCalculated.regionCoefficient
            },
            canSelect() {
                return this.hasPermission('REAL_ESTATE_NEW_COMPARATIVE_ANALOGS_SELECT')
            },
            calculatedComparativeCostObjectTotal() {
                let totalAmount = 0
                let totalArea = 0
                let total = 0
                if (this.realEstate.newComparison.comparativeCostObjects.length > 0) {
                    this.realEstate.newComparison.comparativeCostObjects.forEach((ob) => {
                        totalAmount = totalAmount + ob.amount
                        totalArea = totalArea + ob.area
                        total = total + ob.totalAmount
                    })
                }
                return {
                    calculated: {
                        amount: totalAmount,
                        area: totalArea,
                        totalAmount: total
                    }
                }
            },
            isUserSpecial() {
              return this.profile && (this.profile.username === 'kenjabek' || this.profile.username === 'asadbek_baholovchi')
            }
        },
        created() {
            this.init();
        }
    }
</script>

<style scoped>
    .comparison-table {
        font-size: 14px;
    }
    .comparison-table th {
        /*vertical-align: top;*/
        border: 1px solid #dee2e6;
        border-collapse: collapse;
        background-color: #E9FAFD;
    }
    .comparison-table td {
        border: 1px solid #dee2e6;
        border-collapse: collapse;
    }
    .comparison-table .percentage {
        margin: auto;
        width: 110px !important;
        display: inline-block;
    }
    .comparison-table .percentage div {
        width: 80px !important;
        float: left;
    }
    .comparison-table .percentage span {
        display: block;
        margin: 7px 5px;
        float: left;
    }
    .comparison-table .section-start td {
        background-color: #F3F3F3;
    }
    .comparison-table .section-start > td:first-child {
        font-weight: bold;
    }

    .bg-color {
        background-color: #c2c2c2;
    }
</style>